import React, {useRef, useEffect} from 'react';
import { API } from "aws-amplify";
import { initializeDashboardEmbed } from 'util/dashboard';
import { toast } from 'react-toastify';

export function DashboardsEmbedWrapper(props) {
    
    const quicksightRef = useRef();

    useEffect(() => {
        if (props.dashboardId) {
            async function init() {
                try {
                    const EmbedUrl = await API.get('DashboardApi', `/dashboard/${props.dashboardId}/view`);
                    quicksightRef.current = await initializeDashboardEmbed(EmbedUrl.embedUrl);
                } catch (err) {
                    console.error('Dashboard embed initialization failed:', err);
                    toast(`Failed to load dashboard: ${err.message || 'Unknown error'}`, {
                        type: toast.TYPE.ERROR,
                        autoClose: 5000
                    });
                }
            }
            init();
        }
        return () => {
            if (quicksightRef.current && typeof quicksightRef.current.destroy === 'function') {
                quicksightRef.current.destroy();
            }
        };
    }, [props.dashboardId]);

    return <div className="dashboard-graph-full" id="embeddingContainer" style={{ height: '750px' }} ></div>;
}